import { render, staticRenderFns } from "./order_actions.vue?vue&type=template&id=6470a15b&scoped=true&"
import script from "./order_actions.vue?vue&type=script&lang=js&"
export * from "./order_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470a15b",
  null
  
)

export default component.exports